import IconModal from './IconModal';
export default IconModal;
